import React, { useState, useEffect } from 'react';
import apiClient from '../../utils/apiClient';
import { SectionCard, ChipInput, SaveRow, EmptyHint, palette } from './ui';

export default function SkillsCard({ isDarkMode, items, actions }) {
  const c = palette(isDarkMode);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [draft, setDraft] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    apiClient
      .get('/job-titles/', { params: { skip: 0, limit: 100 } })
      .then(res => {
        const names = (res.data || []).map(t => t.title || t.name).filter(Boolean);
        setSuggestions(names);
      })
      .catch(() => {}); // suggestions are a nice-to-have
  }, []);

  const startEdit = () => {
    setDraft(items.map(s => s.name));
    setEditing(true);
  };

  const save = async () => {
    setSaving(true);
    const existing = items.map(s => s.name);
    const toAdd = draft.filter(name => !existing.includes(name));
    const toRemove = items.filter(s => !draft.includes(s.name));
    let ok = true;
    for (const name of toAdd) {
      ok = (await actions.add({ name })) && ok;
    }
    for (const skill of toRemove) {
      ok = (await actions.remove(skill.id)) && ok;
    }
    setSaving(false);
    if (ok) setEditing(false);
  };

  return (
    <SectionCard
      id="skills"
      title="Skills"
      subtitle="What work can you do? Employers search by skills"
      isDarkMode={isDarkMode}
      onEdit={startEdit}
      editing={editing}
    >
      {!editing ? (
        items.length === 0 ? (
          <EmptyHint isDarkMode={isDarkMode}>e.g. Driving, MS Excel, Cooking, Wiring, Customer service…</EmptyHint>
        ) : (
          <div className="flex flex-wrap gap-2">
            {items.map(s => (
              <span key={s.id} className={`px-3 py-1.5 rounded-full text-sm ${c.chip}`}>{s.name}</span>
            ))}
          </div>
        )
      ) : (
        <div>
          <ChipInput
            isDarkMode={isDarkMode}
            values={draft}
            onChange={setDraft}
            suggestions={suggestions}
            placeholder="Type a skill and press Enter"
          />
          <SaveRow isDarkMode={isDarkMode} onSave={save} onCancel={() => setEditing(false)} saving={saving} />
        </div>
      )}
    </SectionCard>
  );
}
